import { InfiniscrollContainer } from '@/shared/components/export';
import { MarketSignal } from '@/modules/market-signals/model/market-signals/market-signal';
import marketSignalApi from '@/modules/market-signals/api/market-signal-api';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useTimer } from '@/shared/hooks/export';
import TrumpTrackerScrollerEntry from './trump-tracker-scroller-entry';
import articleListStyles from '@/shared/components/flash-highlight.module.scss';

export default function TrumpTrackerScrollerPanel({ conditionId }: { conditionId: string }) {
  const [truths, setTruths] = useState<MarketSignal[]>([]);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [page, setPage] = useState<number>(0);

  useEffect(() => {
    marketSignalApi.getSignalsByAlarmCondition(conditionId, 0).then(v => {
      setTruths(v.content.map(c => c.signalId));
      setHasMore(true);
    });
    // eslint-disable-next-line
  }, []);

  const loadMore = async () => {
    if (!truths) return;

    const newPage = page + 1;
    const newTruths = (
      await marketSignalApi.getSignalsByAlarmCondition(conditionId, newPage)
    ).content.map(c => c.signalId);

    if (newTruths.length > 0) {
      setTruths(prev => [...newTruths, ...prev]);
      setPage(newPage);
    } else {
      setHasMore(false);
    }
  };

  // const [messgs, setMessgs] = useState({});
  // useSubscription<MarketSignalAlarm>('/topic/signals/alert', message => {
  //   setMessgs(prev => [message, prev]);
  //   if (message.conditionId === conditionId) marketSignalApi.getSignalsByIds([message._id]).then(v => setTruths(prev => [v.content[0], ...prev]))
  // });

  useTimer(
    300_000,
    () =>
      marketSignalApi
        .getSignalsByAlarmCondition(conditionId, 0)
        .then(value => setTruths(prev => [...value.content.map(c => c.signalId), ...prev])),
    false,
    'tt-panel-reload',
  );

  const flash = (date: string) => {
    if (dayjs(date).isAfter(dayjs().subtract(5, 'minute'))) return articleListStyles.flashArticle;
    return '';
  };

  const displayTruths = (() => {
    return Array.from(new Map(truths.map(t => [t._id, t])).values()).sort(
      (a, b) => new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime(),
    );
  })();

  return (
    <div className={'h-100 overflow-auto'}>
      <InfiniscrollContainer onLoad={loadMore} hasMore={hasMore} variant="trump-tracker">
        {displayTruths?.map((value, index) => (
          <div key={value._id + '-' + index} className={`small ${flash(value.dateCreated)}`}>
            <TrumpTrackerScrollerEntry truth={value} />
          </div>
        ))}
      </InfiniscrollContainer>
    </div>
  );
}
